import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Value from './value';

export function PropertyTypeValue({ deal, propertyTypes }) {
  const type = propertyTypes.find(type => type.id === deal.propertyTypeId);

  let value;
  if (type) {
    value = type.name;

    const subtype = type.subtypes.find(subtype => subtype.id === deal.propertySubtypeId);
    if (subtype) {
      value = `${value} | ${subtype.name}`;
    }
  }

  return <Value name="propertyType" value={value} />;
}

PropertyTypeValue.propTypes = {
  deal: PropTypes.shape({
    propertyTypeId: PropTypes.number,
    propertySubtypeId: PropTypes.number,
  }).isRequired,
  propertyTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    subtypes: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })).isRequired,
  })).isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
  propertyTypes: state.options.propertyTypes,
});

export default connect(mapStateToProps)(PropertyTypeValue);
